import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import Login from "./pages/auth/Login";
import Registro from "./pages/auth/Registro";
import Dashboard from "./pages/dashboard/Dashboard";
import Clinicas from "./pages/superadmin/Clinicas";
import Agenda from "./pages/app/agenda/Agenda";
import Pacientes from "./pages/app/pacientes/Pacientes";
import DetallePaciente from "./pages/app/pacientes/DetallePaciente";
import HistoriaClinica from "./pages/app/pacientes/HistoriaClinica";
import Caja from "./pages/app/caja/Caja";
import Arqueo from "./pages/app/caja/Arqueo";
import Prestadores from "./pages/app/prestadores/Prestadores";
import DetallePrestador from "./pages/app/prestadores/DetallePrestador";
import Consentimientos from "./pages/app/consentimientos/Consentimientos";
import DetalleConsentimiento from "./pages/app/consentimientos/DetalleConsentimiento";
import Inventario from "./pages/app/inventario/Inventario";
import Metricas from "./pages/app/metricas/Metricas";
import Usuarios from "./pages/app/usuarios/Usuarios";
import Trazabilidad from "./pages/app/usuarios/Trazabilidad";
import Portal from "./pages/app/portal/Portal";
import GestionPortal from "./pages/app/portal/GestionPortal";
import Presupuestos from "./pages/app/presupuestos/Presupuestos";
import DetallePresupuesto from "./pages/app/presupuestos/DetallePresupuesto";
import Financiacion from "./pages/app/financiacion/Financiacion";
import Honorarios from "./pages/app/honorarios/Honorarios";
import Derivaciones from "./pages/app/derivaciones/Derivaciones";
import Facturacion from "./pages/superadmin/Facturacion";
import SuperAdminUsuarios from "./pages/superadmin/Usuarios";
import SuperAdminMetricas from "./pages/superadmin/Metricas";
import Configuracion from "./pages/app/configuracion/Configuracion";
import AnaliticaClientes from "./pages/superadmin/AnaliticaClientes";
import CentroAyuda from "./pages/app/ayuda/CentroAyuda";

function PrivateRoute({ children }) {
  const { currentUser, loading } = useAuth();
  if (loading) return null;
  return currentUser ? children : <Navigate to="/" />;
}

function PublicRoute({ children }) {
  const { currentUser, loading } = useAuth();
  if (loading) return null;
  return !currentUser ? children : <Navigate to="/dashboard" />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={
        <PublicRoute>
          <Login />
        </PublicRoute>
      } />
      <Route path="/registro" element={
        <PublicRoute>
          <Registro />
        </PublicRoute>
      } />
      <Route path="/dashboard" element={
        <PrivateRoute>
          <Dashboard />
        </PrivateRoute>
      } />
      <Route path="/superadmin/clinicas" element={
        <PrivateRoute>
          <Clinicas />
        </PrivateRoute>
      } />
      <Route path="/agenda" element={
        <PrivateRoute>
          <Agenda />
        </PrivateRoute>
      } />
      <Route path="/pacientes" element={
        <PrivateRoute>
          <Pacientes />
        </PrivateRoute>
      } />
      <Route path="/pacientes/:id" element={
        <PrivateRoute>
          <DetallePaciente />
        </PrivateRoute>
      } />
      <Route path="/pacientes/:id/historia" element={
        <PrivateRoute>
          <HistoriaClinica />
        </PrivateRoute>
      } />
      <Route path="/caja" element={
        <PrivateRoute>
          <Caja />
        </PrivateRoute>
      } />
      <Route path="/caja/arqueo" element={
        <PrivateRoute>
          <Arqueo />
        </PrivateRoute>
      } />
      <Route path="/prestadores" element={
        <PrivateRoute>
          <Prestadores />
        </PrivateRoute>
      } />
      <Route path="/prestadores/:id" element={
        <PrivateRoute>
          <DetallePrestador />
        </PrivateRoute>
      } />
      <Route path="/consentimientos" element={
        <PrivateRoute>
          <Consentimientos />
        </PrivateRoute>
      } />
      <Route path="/consentimientos/:id" element={
        <PrivateRoute>
          <DetalleConsentimiento />
        </PrivateRoute>
      } />
      <Route path="/inventario" element={
        <PrivateRoute>
          <Inventario />
        </PrivateRoute>
      } />
      <Route path="/metricas" element={
        <PrivateRoute>
          <Metricas />
        </PrivateRoute>
      } />
      <Route path="/usuarios" element={
        <PrivateRoute>
          <Usuarios />
        </PrivateRoute>
      } />
      <Route path="/usuarios/trazabilidad" element={
        <PrivateRoute>
          <Trazabilidad />
        </PrivateRoute>
      } />
      <Route path="/portal" element={<Portal />} />
      <Route path="/gestion-portal" element={<PrivateRoute><GestionPortal /></PrivateRoute>} />
      
      <Route path="/presupuestos" element={<PrivateRoute><Presupuestos /></PrivateRoute>} />
      <Route path="/presupuestos/:id" element={<PrivateRoute><DetallePresupuesto /></PrivateRoute>} />
      <Route path="/financiacion" element={<PrivateRoute><Financiacion /></PrivateRoute>} />
      <Route path="/honorarios" element={<PrivateRoute><Honorarios /></PrivateRoute>} />
      <Route path="/derivaciones" element={<PrivateRoute><Derivaciones /></PrivateRoute>} />
      <Route path="/superadmin/facturacion" element={<PrivateRoute><Facturacion /></PrivateRoute>} />
      <Route path="/superadmin/usuarios" element={<PrivateRoute><SuperAdminUsuarios /></PrivateRoute>} />
      <Route path="/superadmin/metricas" element={<PrivateRoute><SuperAdminMetricas /></PrivateRoute>} />
      <Route path="/configuracion" element={<PrivateRoute><Configuracion /></PrivateRoute>} />
      <Route path="/superadmin/analitica" element={<PrivateRoute><AnaliticaClientes /></PrivateRoute>} />
      <Route path="/ayuda" element={<PrivateRoute><CentroAyuda /></PrivateRoute>} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <AppRoutes />
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}